import angular from "angular";

import ServiceProviderServicesModuleRouting from "./service-provider-services.module.routing";

export default angular
  .module("vt-service-provider-services", [])
  .config(ServiceProviderServicesModuleRouting);
